/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import * as _ from 'underscore';
import FilterModule from 'app/mixins/FilterModule.js';
import SortModule from 'app/mixins/SortModule.js';
import Utilities from 'app/utility/Utilities.js';


let calculateSocialCounts = function(socials) {
	let i = 0,
		social = null,
		socialTypes = {},
		allSocials = 0,
		name = '',
		socialCounts = [];

	for (i = 0; i < socials.length; ++i) {
		social = socials[i];
		name = ConstantMixin.getPostServiceNameByCode(social.psID);
		if (!socialTypes[name]) {
			socialTypes[name] = {
				type: social.psID,
				count: 0,
				name: name
			};
		}
		socialTypes[name].count++;
		allSocials++;
	}

	for (let key in socialTypes) {
		if (socialTypes.hasOwnProperty(key)) {
			socialCounts.push(socialTypes[key]);
		}
	}

	socialCounts = _.sortBy(socialCounts, 'name');

	// last item is the "all socials type"
	if (socialCounts.length > 1) {
		socialCounts.push({
			'type': '',
			'name': 'All Socials',
			count: allSocials
		});
	}

    return socialCounts;

};

export const socials = (state = defaultState.socials, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
		j = 0,
        socials = [];


    switch (action.type) {
		case constants.UTILITIES_FILTER_STORE:
            if (action.store === 'socials') {
                nextState.filter = {
                    key: action.filter,
                    value: action.value,
                    exact: action.exact
                };
                nextState.filteredList = FilterModule(nextState.list, action.filter, action.value, action.exact);
            }
            break;

        case constants.UTILITIES_SORT_STORE:
            if (action.store === 'socials') {
                nextState.sort = {
                    key: action.key,
                    direction: action.direction
                };
                nextState.list = SortModule(nextState.list, action.key, action.direction);
                if (nextState.filteredList.length > 0) {
                    nextState.filteredList = SortModule(nextState.filteredList, action.key, action.direction);
                }
            }
            break;

		case constants.UTILITIES_CLEAR_FILTER:
			if (action.store === 'socials') {
				nextState.filteredList = [];
				delete nextState.filter;
			}
			break;

        case constants.SOCIAL_LIST:
			if (action.status === constants.STATE_SUCCESS) {
				nextState.list = action.payload;
	            nextState.counts = calculateSocialCounts(nextState.list);
			}
            break;

        case constants.SOCIAL_SHOW:
        case constants.SOCIAL_UPDATE:
			if (action.status === constants.STATE_SUCCESS) {
				if (!action.payload.deletedFlag) {
		            for (i = 0; i < nextState.list.length; ++i) {
		                if (parseInt(nextState.list[i].id, 10) === parseInt(action.payload.id, 10)) {
		                    nextState.list[i] = action.payload;
		                    break;
		                }
		            }
					if (nextState.list.length === 0) {
						nextState.list.push(action.payload);
					}
					if (nextState.filteredList.length) {
						nextState.filteredList = FilterModule(nextState.list, nextState.filter.key, nextState.filter.value, nextState.filter.exact);
					}
				}
			}
            break;

        case constants.SOCIAL_DELETE:
			if (action.status === constants.STATE_SUCCESS) {
	            for (i = 0; i < nextState.list.length; ++i) {
	                if (parseInt(nextState.list[i].id, 10) !== parseInt(action.payload.id, 10)) {
	                    socials.push(nextState.list[i]);
	                }
	            }
	            nextState.list = socials;
	            nextState.counts = calculateSocialCounts(nextState.list);
				if (nextState.filteredList.length) {
					nextState.filteredList = FilterModule(nextState.list, nextState.filter.key, nextState.filter.value, nextState.filter.exact);
				}
			}
            break;

        case constants.SOCIAL_CREATE:
			if (action.status === constants.STATE_SUCCESS) {
				if (_.pluck(nextState.list, 'id').indexOf(action.payload.id) === -1) {
	            	nextState.list.push(action.payload);
					nextState.list = SortModule(nextState.list, nextState.sort.key, nextState.sort.direction);
	            	nextState.counts = calculateSocialCounts(nextState.list);
				}
			}
            break;

        case constants.SOCIAL_LOG:
			if (action.status === constants.STATE_SUCCESS) {
	            for (i = 0; i < nextState.list.length; ++i) {
	                if (parseInt(nextState.list[i].id, 10) === parseInt(action.payload.id, 10)) {
	                    nextState.list[i].log = action.payload.logs;
	                    break;
	                }
	            }
			}
            break;

        case constants.SOCIAL_CHECK_AUTH:
			if (action.status === constants.STATE_SUCCESS) {
	            for (i = 0; i < nextState.list.length; ++i) {
	                if (parseInt(nextState.list[i].id, 10) === parseInt(action.payload.id, 10)) {
	                    nextState.list[i].authTest = action.payload.authTest;
	                    break;
	                }
	            }
			}
            break;

        case constants.SOCIAL_TYPE_LIST:
			if (action.status === constants.STATE_SUCCESS) {
            	nextState.types = action.payload;
			}
            break;

        case constants.SOCIAL_TYPE_DEFAULTS:
            // TODO figure out how to set by id
            if (action.status === constants.STATE_SUCCESS) {
            	nextState.defaults = action.payload;
			}
            break;

        case constants.SOCIAL_QUEUE_COUNT:
			if (action.status === constants.STATE_SUCCESS) {
	            for (i = 0; i < nextState.list.length; ++i) {
	                if (parseInt(nextState.list[i].id, 10) === parseInt(action.payload.id, 10)) {
	                    nextState.list[i].queueCount = action.payload;
	                    break;
	                }
	            }
			}
            break;

		case constants.SOCIAL_GET_FB_GROUP_STATUS:
			if (action.status === constants.STATE_SUCCESS) {
				for (i = 0; i < nextState.list.length; ++i) {
					if (parseInt(nextState.list[i].id, 10) === parseInt(action.payload.id, 10)) {
	                    nextState.list[i].hasGroupApp = action.payload.hasGroupApp;
	                    break;
	                }
				}
			}
			break;

		case constants.SOCIAL_CREATE_BATCH:
			if (action.status === constants.STATE_SUCCESS) {
				if (!nextState.batchCreates[action.payload.jobGuid]) {
					nextState.batchCreates[action.payload.jobGuid] = {};
				}
			}
			break;

		case constants.SOCIAL_BATCH_POLL:
			if (action.status === constants.STATE_SUCCESS) {
				let key = null,
					activeKeys = [];

				// on empty the poll returns an array instead of an empty object
				if (_.isArray(action.payload) && action.payload.length === 0) {
					nextState.batchCreates = {};
				} else if (Object.keys(action.payload).length) {
					activeKeys = Object.keys(action.payload);
					// first update existing/still working jobs
					for (key in activeKeys) {
						if (nextState.batchCreates[key]) {
							nextState.batchCreates[key] = action.payload[key];
						}
					}
					// if a key isn't present anymore, the job is done, remove it
					for (key in Object.keys(nextState.batchCreates)) {
						if (activeKeys.indexOf(key) === -1) {
							delete nextState.batchCreates[key];
						}
					}
				}

			}
			break;

		case constants.SOCIAL_GET_CATEGORIES:
			if (action.status === constants.STATE_SUCCESS) {
				let keys = Object.keys(action.payload);
				if (keys.length) {
					nextState.categories[keys[0]] = action.payload[keys[0]];
				}
			}
			break;

		case constants.SOCIAL_GET_PLAYLISTS:
			if (action.status === constants.STATE_SUCCESS) {
				let keys = Object.keys(action.payload);
				nextState.playlists = {};
				if (keys.length) {
					nextState.playlists[keys[0]] = action.payload[keys[0]];
				}
			}
			break;

		case constants.SOCIAL_GET_POST_ANALYTICS:
			if (action.status === constants.STATE_SUCCESS) {
				let keys = null;
				keys = Object.keys(action.payload);
				nextState.analyzerData[keys[0]] = action.payload[keys[0]];
			}
			break;

        default:
            break;
    }

    return nextState;
};
